/**
 * landscapeOrPortrait
 * Determines if the dashboard is landscape or portrait aspect ratio.
 */
export const landscapeOrPortrait = (height: number, width: number) => (height < width ? 'l' : 'p');
